import { api } from '@api'
import type { FetchParams, PaginatedResponse } from './types'
import { usePaginate } from './usePaginate'
import { Memory } from './usePaginateMemories'

interface AlbumMemoriesParams {
  albumId: string
}

const fetchAlbumMemories = async (
  params?: FetchParams & AlbumMemoriesParams,
): Promise<PaginatedResponse<Memory>> => {
  const queryParams = new URLSearchParams()
  if (params?.pageParam) {
    queryParams.append('page', String(params.pageParam))
  }

  const url = `/albums/${params?.albumId}/memories${queryParams.toString() ? `?${queryParams.toString()}` : ''}`
  const { data } = await api.get<PaginatedResponse<Memory>>(url)
  return data
}

export const usePaginateAlbumMemories = (params: AlbumMemoriesParams) => {
  return usePaginate<Memory>('album-memories', fetchAlbumMemories, params, {
    enabled: !!params.albumId,
  })
}
